module.exports = __webpack_public_path__ + "static/img/o1.80b6666.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/owl/o1.jpg
// module id = fJ1p
// module chunks = 0